"use client";

import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { ReactNode } from 'react';

interface ReCaptchaV3ProviderProps {
  children: ReactNode;
}

export const ReCaptchaV3Provider: React.FC<ReCaptchaV3ProviderProps> = ({ children }) => {
  const siteKey = process.env.NEXT_PUBLIC_RECAPTCHA_V3_SITE_KEY;

  // Return null if no site key - completely disable reCAPTCHA
  if (!siteKey) {
    console.warn('reCAPTCHA v3 site key not found. reCAPTCHA disabled.');
    return <>{children}</>;
  }

  return (
    <GoogleReCaptchaProvider 
      reCaptchaKey={siteKey}
      useRecaptchaNet
      scriptProps={{ async: true, defer: true, appendTo: 'head' }}
    >
      {children}
    </GoogleReCaptchaProvider>
  );
};
